(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('frequently-asked-question', {
            parent: 'entity',
            url: '/frequently-asked-question?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.frequentlyAskedQuestion.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-questions.html',
                    controller: 'FrequentlyAskedQuestionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequentlyAskedQuestion');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionVisibleFor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('frequently-asked-question-detail', {
            parent: 'frequently-asked-question',
            url: '/frequently-asked-question/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.frequentlyAskedQuestion.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-detail.html',
                    controller: 'FrequentlyAskedQuestionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('frequentlyAskedQuestion');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionState');
                    $translatePartialLoader.addPart('frequentlyAskedQuestionVisibleFor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FrequentlyAskedQuestion', function($stateParams, FrequentlyAskedQuestion) {
                    return FrequentlyAskedQuestion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'frequently-asked-question',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('frequently-asked-question-detail.edit', {
            parent: 'frequently-asked-question-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-dialog.html',
                    controller: 'FrequentlyAskedQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FrequentlyAskedQuestion', function(FrequentlyAskedQuestion) {
                            return FrequentlyAskedQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequently-asked-question.new', {
            parent: 'frequently-asked-question',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-dialog.html',
                    controller: 'FrequentlyAskedQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                question: null,
                                answer: null,
                                faqstate: null,
                                visibleFor: null,
                                creationTime: null,
                                updateTime: null,
                                revisionTime: null,
                                priority: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question', null, { reload: 'frequently-asked-question' });
                }, function() {
                    $state.go('frequently-asked-question');
                });
            }]
        })
        .state('frequently-asked-question.edit', {
            parent: 'frequently-asked-question',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-dialog.html',
                    controller: 'FrequentlyAskedQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FrequentlyAskedQuestion', function(FrequentlyAskedQuestion) {
                            return FrequentlyAskedQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question', null, { reload: 'frequently-asked-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('frequently-asked-question.delete', {
            parent: 'frequently-asked-question',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/frequently-asked-question/frequently-asked-question-delete-dialog.html',
                    controller: 'FrequentlyAskedQuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FrequentlyAskedQuestion', function(FrequentlyAskedQuestion) {
                            return FrequentlyAskedQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('frequently-asked-question', null, { reload: 'frequently-asked-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
